export const STORES = [
  {
    slug: "hsr-layout",
    name: "HSR Layout",
    address: "27th Main Rd, Sector 1, Agara Village, 1st Sector, HSR Layout, Bengaluru - 560102",
    phone: "+91 63664 37841",
    tel: "+916366437841",
    maps: "https://www.google.com/maps/search/?api=1&query=Tyre%20Empire%20-%20HSR%20Layout%20Bangalore",
  },
  {
    slug: "hosa-road",
    name: "Hosa Road",
    address: "77, Hosa Rd, Electronic City, Bengaluru - 560100",
    phone: "+91 63664 37841",
    tel: "+916366437841",
    maps: "https://www.google.com/maps/search/?api=1&query=Tyre%20Empire%20-%20Hosa%20Road%20Bangalore",
  },
  {
    slug: "varthur-sarjapur",
    name: "Varthur-Sarjapur",
    address: "4&5, Myhna Square, SH-35, Gunjur, Near Prestige Lakeside Habitat, Bengaluru - 560087",
    phone: "+91 63664 37841",
    tel: "+916366437841",
    maps: "https://www.google.com/maps/search/?api=1&query=Tyre%20Empire%20-%20Varthur-Sarjapur%20Bangalore",
  },
  {
    slug: "whitefield",
    name: "Whitefield",
    address: "633, opp. Sigma Tech Park, Ramagondanahalli, Whitefield, Varthur, Bengaluru - 560066",
    phone: "+91 63664 37841",
    tel: "+916366437841",
    maps: "https://www.google.com/maps/search/?api=1&query=Tyre%20Empire%20-%20Whitefield%20Bangalore",
  },
  {
    slug: "itpl-brookfield",
    name: "ITPL Road Brookfield",
    address: "6/2, ITPL Main Road, Kundalahalli Gate, BEML Layout, Brookfield, Bengaluru - 560037",
    phone: "+91 63664 37841",
    tel: "+916366437841",
    maps: "https://www.google.com/maps/search/?api=1&query=Tyre%20Empire%20-%20ITPL%20Road%20Brookfield-Whitefield%20Bangalore",
  },
];

export const STORE_NAMES = STORES.map((s) => s.name);
